module.exports = __webpack_public_path__ + "img/category_42.c2b82d7d.png";